import { useEffect } from "react";
import { BrandConfig } from "./types";

// Aplica título e favicon da marca. Default restaura os valores do index.html
// (`Autenticação - Atem` + /favicon.ico), inclusive na troca de marca em runtime na SPA.
// Movido de Login/index.tsx para valer também em acesso direto (ex.: link do e-mail).
export function useBrandDocumentMeta(brand: BrandConfig): void {
  useEffect(() => {
    const isBranded = brand.id !== "default";
    document.title = isBranded ? `Autenticação - ${brand.portalName}` : "Autenticação - Atem";

    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = isBranded ? brand.assets.logoIcon ?? brand.assets.logo : "/favicon.ico";
  }, [brand.id, brand.portalName, brand.assets.logoIcon, brand.assets.logo]);
}
